<a class="navMenu__link" routerLinkActive="active" [id]="route.icon" [routerLink]="route.route">
  @if (route.icon) {
    <mat-icon>
      {{ route.icon }}
    </mat-icon>
  }
  <span class="max-w-32">{{ route.label }}</span>
</a>
